<template>
    <section class="-mt-28 relative  pb-10">

      <div
        :class="[
          'grid grid-cols-1 ',
          `md:grid-cols-${Math.min(planos.length, 6)}`,
          `lg:grid-cols-${Math.min(planos.length, 6)}`,
          `xl:grid-cols-${Math.min(planos.length, 6)}`
        ]"
        class="gap-8 max-w-7xl mx-auto"
      >

      
        <div
          v-for="(plano, index) in planos"
          :key="index"
          :class="[
            'relative pt-6 rounded-2xl shadow-lg space-y-4 p-10 flex flex-col items-center border-t-4 ',
            plano.promocional ? 'bg-white border-[#ff687c]' : 'bg-white border-cormenubotaoplanos'
          ]"
        >
          <!-- Selo -->
          <span
            v-if="plano.promocional"
            class="absolute top-4 -translate-y-full text-1-xs bg-[#ff687c] text-white px-6 py-2 rounded-full shadow-md "
          >
            PROMOÇÃO
          </span>
          <h3 class="text-xl font-bold text-gray-900 mb-2 mt-4">{{ plano.nome }}</h3>
          <p class="italic text-gray-500 mb-4">{{ plano.descricao }}</p>
  
                <!-- Exibe valor original e desconto APENAS se houver desconto -->
            <template v-if="getDescontoPercentual(plano) > 0">
            <p class="line-through text-sm text-gray-400">
                R$ {{ formatPreco(plano.valor) }}
            </p>
            <p class="text-3xl font-bold text-cormenubotaoplanos mb-1">
                R$ {{ calcularDesconto(plano) }}
            </p>
            <p class="text-pink-400 text-xs mb-1">{{ getDescontoTexto(plano) }}</p>
            </template>

            <!-- Caso não tenha desconto, mostra só o valor -->
            <template v-else>
            <p class="text-3xl font-bold text-cormenubotaoplanos mb-3">
                R$ {{ formatPreco(plano.valor) }}
            </p>
            </template>

         
          <p v-if="periodoSelecionadoVpsLinux !== '1'" class="text-gray-400 text-xs mb-4">
            * Valor integral: R${{ valorIntegral(plano) }}
          </p>
  
          <router-link
            :to="`/assineja-vps-linux-dedicado?planoId=${plano.id}`"
            class="bg-cormenubotaoplanos text-white px-6 py-2 rounded-full font-semibold hover:brightness-110 transition mb-2 inline-block"
          >
          <span class="block leading-tight min-w-[100px] text-center mt-2 mb-2">ASSINE JÁ</span>
        </router-link>

          <p class="text-xs text-gray-500 mb-6">
            Preço na contratação de {{ periodoSelecionadoVpsLinux }} meses
          </p>
  
          <ul class="space-y-4 text-lg text-gray-700 w-full">
            <li v-for="(item, i) in montarRecursos(plano)" :key="i" class="flex items-center gap-3">
              <img :src="item.icon" alt="icon" class="w-5 h-5" />
              {{ item.label }}
            </li>
          </ul>
        </div>
      </div>
  
      <div class="text-center mt-12">
        <button
            @click="toggleTermos"
            class="bg-cormenubotaoplanos text-white text-sm px-6 py-2 rounded-full font-medium hover:brightness-110 transition"
        >
            Termos de pagamento
        </button>

        <!-- Caixa que aparece abaixo -->
        <div v-if="mostrarTermos" class="mt-6 bg-gray-100 text-gray-800 p-6 max-w-2xl mx-auto rounded-xl text-sm leading-relaxed shadow">
            <p>Os planos são pagos de forma integral, SEM PARCELAMENTO.</p> 
            O valor apresentado refere-se ao preço total do plano dividido pela quantidade de meses que você está adquirindo.
        </div>
      </div>

    </section>
  </template>
  
  <script setup>
  import { ref, onMounted } from 'vue'
  import axios from '@/services/api'
  import { periodoSelecionadoVpsLinux } from '@/store/periodoStore'
  const mostrarTermos = ref(false)

  const toggleTermos = () => {
    mostrarTermos.value = !mostrarTermos.value
  }

  const planos = ref([])

  onMounted(async () => {
    try {
      const response = await axios.get('/api/planos/listarativos')
      planos.value = response.data
        .filter(p => p.ativo)
        .filter(p => p.planoTipo === 'VPSLINUX')
        .sort((a, b) => a.ordem - b.ordem)
    } catch (error) {
      console.error('Erro ao buscar planos:', error)
    }
  })

  const formatPreco = valor => Number(valor).toFixed(2).replace('.', ',')

  const getDescontoPercentual = plano => {
    if (periodoSelecionadoVpsLinux.value === '6') return plano.desconto2 || 0
    if (periodoSelecionadoVpsLinux.value === '12') return plano.desconto3 || 0
    return plano.desconto1 || 0
  }

  const calcularDesconto = plano => {
    const descontoPercentual = getDescontoPercentual(plano)
    const valorComDesconto = plano.valor * (1 - descontoPercentual / 100)
    return formatPreco(valorComDesconto)
  }

  const valorIntegral = plano => {
    const descontoPercentual = getDescontoPercentual(plano)
    const valorComDesconto = plano.valor * (1 - descontoPercentual / 100)
    return formatPreco(valorComDesconto * Number(periodoSelecionadoVpsLinux.value))
  }

  const getDescontoTexto = plano => {
    const d = getDescontoPercentual(plano)
    return d > 0 ? `${d}% de desconto` : ''
  }

  const montarRecursos = plano => [
    { label: `${plano.processamento} vCore @ 2.6 GHz`, icon: '/icones-descricao-planos/processamento.svg' },
    { label: `${plano.ram1} GB RAM`, icon: '/icones-descricao-planos/memoria.svg' },
    { label: `${plano.disco} GB de SSD`, icon: '/icones-descricao-planos/disco.svg' },
    { label: '1 IP Dedicado', icon: '/icones-descricao-planos/ip.svg' },
    { label: 'Ubuntu, Debian', icon: '/icones-descricao-planos/linux.svg' },
    { label: 'Rocky, Almalinux', icon: '/icones-descricao-planos/linux.svg' },
    { label: 'Acesso Root', icon: '/icones-descricao-planos/root.svg' },
    { label: 'Anti-DDoS', icon: '/icones-descricao-planos/ddos.svg' }
  ]
  </script>
  
  <style scoped>
  li svg,
  li img {
    min-width: 1.25rem;
    height: 1.25rem;
  }
  </style>
